<main class="site-content fix-height">
  <div class="container login forget-password">
    <!-- Logo for the header -->
    <div class="logo">
      <img src="/assets/images/qunote-logo-g.svg" alt="qunote">
    </div>
    <!-- Error message Display -->
    <div class="alert-message">
      <div class="alert alert-danger alert-dismissible fade in" role="alert" *ngIf="showFailMessage && !showmessage">
        {{messagetext}}
      </div>
    </div>
    <!-- Email Enter Block -->
    <div *ngIf="!showmessage">
      <h1>{{'fp.heading' | translate}}</h1>
      <form [formGroup]="forgetForm" (ngSubmit)="onSubmit()">
        <div class="input-row">
          <div class="input-field">
            <input type="email" #emailName formControlName="email"
              [ngClass]="{'is-invalid':  f.email.errors && f.email.dirty }" class="input"
              placeholder="{{'registration.primary.email' | translate}}">
            <div *ngIf="f.email.errors && f.email.dirty" class="invalid-feedback">
              <div *ngIf="f.email.errors.required" class="error-message-form">
                {{'registration.primary.emailRequired' | translate}}</div>
              <div *ngIf="(f.email.errors.email || f.email.invalid) && f.email.value" class="error-message-form">
                {{'registration.primary.emailInvalid' | translate}}</div>
              <div *ngIf="(f.email.errors.maxlength)" class="error-message-form extraErrordiv">
                {{'registration.primary.emailExceed' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="btns">
          <input type="submit" name="submit" value="{{'fp.find' | translate}}"
            class="btn btn-secondary btn-block submit" [disabled]="!forgetForm.valid">
          <button class="btn btn-link btn-block" routerLink="/login">{{'fp.btn_signin' | translate}}</button>
        </div>
      </form>
    </div>
    <!-- show message after success -->
    <div class="container forget-password" *ngIf="showmessage">
      <h1>{{'fp.fp_message_head' | translate}}</h1>
      <h2>{{'fp.fp_message_body' | translate}}</h2>
      <div class="btns">
        <div class="input-row"></div>
        <input type="button" (click)="Resetview()" name="cancel" value="{{'fp.fp_tryAgain' | translate}}"
          class="btn btn-secondary btn-block cancel">
        <button class="btn btn-link btn-block" routerLink="/login">{{'fp.btn_signin' | translate}}</button>
      </div>
    </div>

    <!-- Signup Link -->
    <div class="front front-cta">
      <div class="front-txt">
        {{'login.signup' | translate}}
      </div>
      <br />
      <button routerLink="/signup" type="button" class="btn btn-primary">
        {{'login.signup_btn' | translate}}
      </button>
    </div>
  </div>

</main>